import { Component, OnInit} from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MatToolbarModule } from "@angular/material/toolbar";
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

import { KnownSteps } from "../../../../shared/models/session.model";
import { DirectSessionLogicService } from "../../../../shared/direct-session-logic.service";
import { CircleStepperComponent } from "../ag-radial-pie-graph/ag-radial-pie-graph.component";
import { LayoutChangeService } from "../../../../shared/layout-change.service";



@Component({
    selector: "mobile-position-bar",
    template: `
        <div    class="text-white col font-medium mt-6 text-center leading-6 "
                style="align-self: flex-start; justify-content: flex-start;"
        >
        <div class="d-inline-flex flex-row ">
            <app-ag-radial-pie-graph class="radial-graph row-4" 
            [completedSteps]="completedSteps" 
            [maxSteps]="maxSteps"
            [stepsList]="knownStepsData"
            ></app-ag-radial-pie-graph>
            <div
            class="graph-name-container text-white row-8"
            >
                <div class="thisStepBar col ">{{currentPageBreadCrumb}}</div>
                <div *ngIf="!finalStep && nextPageBreadcrumb" class="nextStepBar col ">Next: {{nextPageBreadcrumb}}</div>
            </div>
        </div>
        </div>
    `,
    styleUrls: ["./mobile-position-bar.component.scss"],
    standalone: true,
    imports: [ 
        RouterModule, 
        MatToolbarModule,
        CommonModule,
        CircleStepperComponent
    ],

})

export class MobilePositionBar implements OnInit {

    isMobile: boolean = false;

    constructor(
        public directSessionLogic: DirectSessionLogicService,
        private responsive: BreakpointObserver,
        private layoutChangeService: LayoutChangeService
    ) {
    }


    ngOnInit(){
        this.responsive.observe([
            Breakpoints.XSmall
        ])
            .subscribe(result => {
                this.isMobile = false;
                if (result.matches)
                this.isMobile = true;
        });
    }


    get knownStepsData(): KnownSteps[] {
        return this.directSessionLogic.knownStepsListSignal();
    }
    get currentStepIndex(): number {
        return this.directSessionLogic.currentStepSignal();
    }
    get thisStepRef(): KnownSteps | undefined {
        return this.knownStepsData[this.currentStepIndex];
    }

    get currentPageBreadCrumb(): string {
        return this.thisStepRef?.breadcrumbName?.toString() ?? "";
    }
    get finalStep(): boolean {
        return this.thisStepRef !== undefined
            && (this.thisStepRef.index + 1) >= this.knownStepsData.length;
    }
    get nextPageBreadcrumb(): string {
        if(this.thisStepRef === undefined || this.finalStep) return "";
        return this.knownStepsData[this.thisStepRef.index + 1]?.breadcrumbName?.toString() ?? "";
    }
    get completedSteps(): number {
        return this.knownStepsData.filter(step => step.completed === true).length;
    }
    get maxSteps(): number {
        return this.knownStepsData.length;
    }

}